<!--
  * 角色权限控制，包裹组件，根据角色显示组件，无权限时显示 noPermContent 内容
-->
<template>
  <template v-if="hasPermR(r)">
    <slot></slot>
  </template>
  <template v-else>
    <slot name="noPermContent"></slot>
  </template>
</template>
<script setup lang="ts">
import type { PermRoleKey } from '@/types/permission';
import { hasPermR } from '@/utils/permission';

defineProps<{
  r: PermRoleKey | PermRoleKey[];
}>();
</script>
